import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { ShipstationSetting } from '../types'

export type FetchShipstationSettingsForOptionsAction = FSA<undefined, ShipstationSetting[], string>
type FetchShipstationSettingsForOptions = (searchText?: string) => MrxThunk<FetchShipstationSettingsForOptionsAction>
type QueryResponse = GraphQLResponse<'shipstationSettingsForOptions', ShipstationSetting[]>

const FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS = `
  query fetchShipstationSettingsForOptions ($workspaceId: Int!, $limit: Int, $searchText: String) {
    shipstationSettingsForOptions (workspaceId: $workspaceId, limit: $limit, searchText: $searchText) {
      id
      name
    }
  }
`

const fetchShipstationSettingsForOptions: FetchShipstationSettingsForOptions = (searchText) => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS,
      variables: { workspaceId, searchText }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { shipstationSettingsForOptions } = data
    if (!shipstationSettingsForOptions) {
      throw new Error("Can't get shipstation settings!")
    }

    dispatch({
      type: t.FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS,
      payload: shipstationSettingsForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchShipstationSettingsForOptions }
